import { useMutation } from "@tanstack/react-query";
import { createSession } from "../openapi/api-client";

export const useCreateSession = (
  projectId: string,
  target: { appInstallationId: string } | { containerId: string },
) => {
  return useMutation({
    mutationFn: () => {
      return createSession(
        {
          projectId,
          ...target,
        },
        {},
      );
    },
  });
};
